<template>
  <Navbar></Navbar>
  <div class="product-detail-page">
    <div class="detail-banner">
      <div class="img-box detail-banner-img"><img src="/assets/product/engine/4N20B/4N20B.jpg" alt=""></div>
      <div class="detail-banner-r">
        
        <div class="detail-banner-t2">4N20B 2.0 GDIT Gasoline Engine</div>
        <div class="detail-banner-desc">
          The 4N20B series is a new-generation high-performance GDIT (Gasoline Direct Injection Turbocharged) gasoline engine that also achieves high thermal efficiency. It features high performance, high thermal efficiency, low emissions, and excellent compatibility;<br />
          It can be paired with various hybrid systems and is suitable for SUVs, pickups, and MPVs.
        </div>
      </div>
    </div>

    <div class="detail-box">
      <div class="detail-title">Powerful Performance</div>
      <div class="detail-desc"></div>
      <div class="detail-utils">
        <div class="detail-utils-item">
          <div class="detail-utils-d">Maximum Power（6000rpm）</div>
          <div class="detail-utils-u">180kW</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Maximum Torque（1700-4000rpm）</div>
          <div class="detail-utils-u">380N·m</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Minimum BSFC</div>
          <div class="detail-utils-u">208.6g/kW·h</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Thermal Efficiency</div>
          <div class="detail-utils-u">＞40%</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Emission Standard</div>
          <div class="detail-utils-u">China 6B, with upgrade potential to China 7</div>
        </div>
      </div>
    </div>

    <div class="detail-box">
      <div class="detail-title">Core Technologies</div>
      <div class="detail-desc"></div>
      <div class="detail-four-list">
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4N20B/4N20B-1.jpg" alt=""></div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">WGT supercharger with high temperatures resistance and high efficiency</div>
          <div class="detail-four-desc">
            The turbine housing uses a nickel-based alloy to be able to withstand high temperatures, raising temperature resistance from 980°C to 1050°C for improved exhaust energy utilization. An integrated exhaust port increases flow by 4.2%, 
            enabling 200 N·m @ 1000 rpm for enhanced low-speed power.
          </div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">Low-Pressure EGR System</div>
          <div class="detail-four-desc">
            110mJ high-energy ignition, humidity monitoring, and a no-low-point EGR system design significantly increase EGR rates while ensuring combustion stability. This reduces pumping losses, improves combustion efficiency, 
            and expands the economical fuel consumption zone by 7-12% compared to the previous generation, covering common vehicle operating conditions.
          </div>
        </div>
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4N20B/4N20B-2.jpg" alt=""></div>
        </div>
      </div>

    </div>
  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
  nextTick(() => {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach((container, index) => {
      const containerKey = `swiper_${index}`;
      container.dataset.swiperKey = containerKey;
      const swiperInstance = new Swiper(container, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        preventClicks: true,
        effect: 'fade',
      });
      swiperInstances.value[containerKey] = swiperInstance;
    });

    bindTabClickEvent();
  });
});
function bindTabClickEvent() {
  const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

  allSwiperLists.forEach((swiperList) => {
    const tabItems = swiperList.querySelectorAll('.detail-tab-item');
    const targetSwiperContainer = swiperList.querySelector('.swiper-container');

    if (!tabItems.length || !targetSwiperContainer) return;

    const containerKey = targetSwiperContainer.dataset.swiperKey;
    const targetSwiper = swiperInstances.value[containerKey];
    if (!targetSwiper) return;

    const handleTabAction = (tabItem, localTabIndex) => {
      tabItems.forEach(item => item.classList.remove('active'));
      tabItem.classList.add('active');
      targetSwiper.slideTo(localTabIndex, 300, true);
    };
    tabItems.forEach((tabItem, localTabIndex) => {
      const handleTabClickWrapper = () => {
        handleTabAction(tabItem, localTabIndex);
      };
      tabItem.removeEventListener('click', handleTabClickWrapper);
      tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
      tabItem.addEventListener('click', handleTabClickWrapper);
      tabItem.addEventListener('mouseenter', handleTabClickWrapper);
    });
  });
}

</script>

<script>
export const pageConfig = {
  title: '4N20B 2.0 GDIT Gasoline Engine - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/engine/4N20B.html'

};

import { createApp } from 'vue';
import App from './4N20B.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./4N20B.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss" scoped></style>